import { render } from "./SalesRelat.vue?vue&type=template&id=bd4a7d2c"
import script from "./SalesRelat.vue?vue&type=script&lang=js"
export * from "./SalesRelat.vue?vue&type=script&lang=js"

import "./SalesRelat.vue?vue&type=style&index=0&id=bd4a7d2c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__